import React from "react";
import "./Services.css";
import { Box } from "@mui/material";

const Recipt = () => {
  return <Box>Your recipt have been sent to your email</Box>;
};

export default Recipt;
